module.exports = __webpack_public_path__ + "img/logo_new.3a9d6339.svg";